import { hospitalEntityName } from '../../../../backend/config/classifiers/entities/defineHospitalClassifier';
import { languageEntityName } from '../../../../backend/config/classifiers/entities/defineLanguageClassifier';
import { languageFluencyEntityName } from '../../../../backend/config/classifiers/entities/defineLanguageFluencyClassifier';
import { skillEntityName } from '../../../../backend/config/classifiers/entities/defineSkillClassifier';
import { trainingEntityName } from '../../../../backend/config/classifiers/entities/defineTrainingClassifier';
import { writtenAbilityEntityName } from '../../../../backend/config/classifiers/entities/defineWrittenAbilityClassifier';
import { allowManageCredentialingClassifiers, allowManageHospitalsClassifier, allowManageSkillsAndTrainingsClassifiers, } from '../../../../backend/features/permissions/shared';
import { capitalized } from '../../../../backend/utils/stringFunctions';
import { AbmsCertificationAdminPage, AbnsCertificationAdminPage, AbppCertificationAdminPage, AoaCertificationAdminPage, AprnSpecialtyAdminPage, AscpSpecialtyAdminPage, BoardOfPharmaceuticalSpecialtyAdminPage, CardiovascularSpecialtyAdminPage, DentalSpecialtyAdminPage, DeploymentDurationAdminPage, DeploymentTravelWillingnessAdminPage, DeploymentTypeAdminPage, DriverLicenseEndorsementAdminPage, EmergencyContactRelationshipAdminPage, EyeColorAdminPage, HairColorAdminPage, HospitalAdminPage, IncidentTypeAdminPage, JasBoardAdminPage, LaboratoryTechnicianSpecialtyAdminPage, LaboratoryTechnologistSpecialAdminPage, LanguageAdminPage, LanguageFluencyAdminPage, MaritalStatusAdminPage, MedicalRecordsItSpecialtyAdminPage, MhcSpecialtyAdminPage, OccupationAdminPage, OccupationCredentialAdminPage, OccupationFunctionAdminPage, OccupationGroupAdminPage, OccupationReportAdminPage, PharmacySpecialtyAdminPage, PhysicianAssistantExperienceAdminPage, PriorCommitmentAdminPage, ProfessionalStatusAdminPage, RadiologicSpecialtyAdminPage, ReferralOptionAdminPage, SkillAdminPage, TrainingAdminPage, TribeAdminPage, VeterinarianSpecialtyAdminPage, VeterinarianTechSpecialtyAdminPage, WrittenAbilityAdminPage, } from '../components';
const groups = {
    general: 'General',
    personalInformation: 'Personal Information',
    deploymentAndPriorCommitments: 'Deployment and Prior Commitments',
    skillsAndTrainings: 'Skills and Trainings',
    stateLevel: 'State Level',
    occupations: 'Occupations',
    medicalSpecialties: 'Medical Specialties',
    missions: 'Missions',
};
// please keep this list sorted
export const getCredentialingAdminPages = (userState) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!allowManageCredentialingClassifiers(userState) &&
        !allowManageHospitalsClassifier(userState) &&
        !allowManageSkillsAndTrainingsClassifiers(userState)) {
        return [];
    }
    const availablePages = [];
    if ((_a = userState.credentialing) === null || _a === void 0 ? void 0 : _a.featureFlags.includes('medicalSpecialties')) {
        availablePages.push(...[
            {
                name: 'AbmsCertification',
                path: 'abmscertification',
                label: 'ABMS Certification',
                groupLabel: groups.medicalSpecialties,
                component: AbmsCertificationAdminPage,
            },
            {
                name: 'AbnsCertification',
                path: 'abnscertification',
                label: 'ABNS Certification',
                groupLabel: groups.medicalSpecialties,
                component: AbnsCertificationAdminPage,
            },
            {
                name: 'AbppCertification',
                path: 'abppcertification',
                label: 'ABPP Certification',
                groupLabel: groups.medicalSpecialties,
                component: AbppCertificationAdminPage,
            },
            {
                name: 'AoaCertification',
                path: 'aoacertification',
                label: 'AOA Certification',
                groupLabel: groups.medicalSpecialties,
                component: AoaCertificationAdminPage,
            },
            {
                name: 'AprnSpecialty',
                path: 'aprnspecialty',
                label: 'APRN Specialty',
                groupLabel: groups.medicalSpecialties,
                component: AprnSpecialtyAdminPage,
            },
            {
                name: 'AscpSpecialty',
                path: 'ascpspecialty',
                label: 'ASCP Specialty',
                groupLabel: groups.medicalSpecialties,
                component: AscpSpecialtyAdminPage,
            },
            {
                name: 'BoardOfPharmaceuticalSpecialty',
                path: 'boardofpharmaceuticalspecialty',
                label: 'Board Of Pharmaceutical Specialty',
                groupLabel: groups.medicalSpecialties,
                component: BoardOfPharmaceuticalSpecialtyAdminPage,
            },
            {
                name: 'CardiovascularSpecialty',
                path: 'cardiovascularspecialty',
                label: 'Cardiovascular Specialty',
                groupLabel: groups.medicalSpecialties,
                component: CardiovascularSpecialtyAdminPage,
            },
            {
                name: 'DentalSpecialty',
                path: 'dentalspecialty',
                label: 'Dental Specialty',
                groupLabel: groups.medicalSpecialties,
                component: DentalSpecialtyAdminPage,
            },
            {
                name: 'LaboratoryTechnicianSpecialty',
                path: 'laboratorytechnicianspecialty',
                label: 'Laboratory Technician Specialty',
                groupLabel: groups.medicalSpecialties,
                component: LaboratoryTechnicianSpecialtyAdminPage,
            },
            {
                name: 'LaboratoryTechnologistSpecial',
                path: 'laboratorytechnologistspecial',
                label: 'Laboratory Technologist Special',
                groupLabel: groups.medicalSpecialties,
                component: LaboratoryTechnologistSpecialAdminPage,
            },
            {
                name: 'MedicalRecordsItSpecialty',
                path: 'medicalrecordsitspecialty',
                label: 'Medical Records IT Specialty',
                groupLabel: groups.medicalSpecialties,
                component: MedicalRecordsItSpecialtyAdminPage,
            },
            {
                name: 'MhcSpecialty',
                path: 'mhcspecialty',
                label: 'MHC Specialty',
                groupLabel: groups.medicalSpecialties,
                component: MhcSpecialtyAdminPage,
            },
            {
                name: 'PharmacySpecialty',
                path: 'pharmacyspecialty',
                label: 'Pharmacy Specialty',
                groupLabel: groups.medicalSpecialties,
                component: PharmacySpecialtyAdminPage,
            },
            {
                name: 'PhysicianAssistantExperience',
                path: 'physicianassistantexperience',
                label: 'Physician Assistant Experience',
                groupLabel: groups.medicalSpecialties,
                component: PhysicianAssistantExperienceAdminPage,
            },
            {
                name: 'RadiologicSpecialty',
                path: 'radiologicspecialty',
                label: 'Radiologic Specialty',
                groupLabel: groups.medicalSpecialties,
                component: RadiologicSpecialtyAdminPage,
            },
            {
                name: 'VeterinarianSpecialty',
                path: 'veterinarianspecialty',
                label: 'Veterinarian Specialty',
                groupLabel: groups.medicalSpecialties,
                component: VeterinarianSpecialtyAdminPage,
            },
            {
                name: 'VeterinarianTechSpecialty',
                path: 'veterinariantechspecialty',
                label: 'Veterinarian Tech Specialty',
                groupLabel: groups.medicalSpecialties,
                component: VeterinarianTechSpecialtyAdminPage,
            },
        ]);
    }
    if ((_b = userState.credentialing) === null || _b === void 0 ? void 0 : _b.featureFlags.includes('deploymentAndPriorCommitments')) {
        availablePages.push(...[
            {
                name: 'DeploymentDuration',
                path: 'deploymentduration',
                label: 'Deployment Duration',
                groupLabel: groups.deploymentAndPriorCommitments,
                component: DeploymentDurationAdminPage,
            },
            {
                name: 'DeploymentTravelWillingness',
                path: 'deploymenttravelwillingness',
                label: 'Deployment Travel Willingness',
                groupLabel: groups.deploymentAndPriorCommitments,
                component: DeploymentTravelWillingnessAdminPage,
            },
            {
                name: 'DeploymentType',
                path: 'deploymenttype',
                label: 'Deployment Type',
                groupLabel: groups.deploymentAndPriorCommitments,
                component: DeploymentTypeAdminPage,
            },
            {
                name: 'EmergencyContactRelationship',
                path: 'emergencycontactrelationship',
                label: 'Emergency Contact Relationship',
                groupLabel: groups.deploymentAndPriorCommitments,
                component: EmergencyContactRelationshipAdminPage,
            },
            {
                name: 'PriorCommitment',
                path: 'priorcommitment',
                label: 'Prior Commitment',
                groupLabel: groups.deploymentAndPriorCommitments,
                component: PriorCommitmentAdminPage,
            },
        ]);
    }
    if ((_c = userState.credentialing) === null || _c === void 0 ? void 0 : _c.featureFlags.includes('skillsAndTrainings')) {
        availablePages.push(...[
            {
                name: 'Language',
                path: 'language',
                label: 'Language',
                groupLabel: groups.skillsAndTrainings,
                component: LanguageAdminPage,
            },
            {
                name: 'LanguageFluency',
                path: 'languagefluency',
                label: 'Language Fluency',
                groupLabel: groups.skillsAndTrainings,
                component: LanguageFluencyAdminPage,
            },
            { name: 'Skill', path: 'skill', label: 'Skill', groupLabel: groups.skillsAndTrainings, component: SkillAdminPage },
            {
                name: 'Training',
                path: 'training',
                label: 'Training',
                groupLabel: groups.skillsAndTrainings,
                component: TrainingAdminPage,
            },
            {
                name: 'WrittenAbility',
                path: 'writtenability',
                label: 'Written Ability',
                groupLabel: groups.skillsAndTrainings,
                component: WrittenAbilityAdminPage,
            },
        ]);
    }
    if ((_d = userState.credentialing) === null || _d === void 0 ? void 0 : _d.featureFlags.includes('tribe')) {
        availablePages.push({ name: 'Tribe', path: 'tribe', label: 'Tribe', groupLabel: groups.stateLevel, component: TribeAdminPage });
    }
    if ((_e = userState.credentialing) === null || _e === void 0 ? void 0 : _e.featureFlags.includes('occupations')) {
        availablePages.push(...[
            { name: 'Hospital', path: 'hospital', label: 'Hospital', groupLabel: groups.occupations, component: HospitalAdminPage },
            {
                name: 'Occupation',
                path: 'occupation',
                label: 'Occupation',
                groupLabel: groups.occupations,
                component: OccupationAdminPage,
            },
            {
                name: 'OccupationFunction',
                path: 'occupationfunction',
                label: 'Occupation Emergency Support Function',
                groupLabel: groups.occupations,
                component: OccupationFunctionAdminPage,
            },
            {
                name: 'OccupationGroup',
                path: 'occupationgroup',
                label: 'Occupation Group',
                groupLabel: groups.occupations,
                component: OccupationGroupAdminPage,
            },
            {
                name: 'OccupationReport',
                path: 'occupationreport',
                label: 'Occupation MRC Report',
                groupLabel: groups.occupations,
                component: OccupationReportAdminPage,
            },
            {
                name: 'CurrentProfessionalStatus',
                path: 'currentprofessionalstatus',
                label: 'Professional Status',
                groupLabel: groups.occupations,
                component: ProfessionalStatusAdminPage,
            },
            { name: 'JasBoard', path: 'jasboard', label: 'JAS Board', groupLabel: groups.general, component: JasBoardAdminPage },
        ]);
        if ((_f = userState.credentialing) === null || _f === void 0 ? void 0 : _f.featureFlags.includes('credential')) {
            availablePages.push({
                name: 'OccupationCredential',
                path: 'occupationcredential',
                label: 'Occupation Credential',
                groupLabel: groups.occupations,
                component: OccupationCredentialAdminPage,
            });
        }
    }
    if ((_g = userState.credentialing) === null || _g === void 0 ? void 0 : _g.featureFlags.includes('personalInformation')) {
        availablePages.push(...[
            {
                name: 'DriverLicenseEndorsement',
                path: 'driverlicenseendorsement',
                label: 'Driver License Endorsement',
                groupLabel: groups.personalInformation,
                component: DriverLicenseEndorsementAdminPage,
            },
            {
                name: 'EyeColor',
                path: 'eyecolor',
                label: 'Eye Color',
                groupLabel: groups.personalInformation,
                component: EyeColorAdminPage,
            },
            {
                name: 'HairColor',
                path: 'haircolor',
                label: 'Hair Color',
                groupLabel: groups.personalInformation,
                component: HairColorAdminPage,
            },
            {
                name: 'MaritalStatus',
                path: 'maritalstatus',
                label: 'Marital Status',
                groupLabel: groups.personalInformation,
                component: MaritalStatusAdminPage,
            },
        ]);
    }
    if ((_h = userState.credentialing) === null || _h === void 0 ? void 0 : _h.featureFlags.includes('general')) {
        availablePages.push(...[
            {
                name: 'IncidentType',
                path: 'incidenttype',
                label: 'Incident Type',
                groupLabel: groups.general,
                component: IncidentTypeAdminPage,
            },
            {
                name: 'ReferralOption',
                path: 'referraloption',
                label: 'Referral Option',
                groupLabel: groups.general,
                component: ReferralOptionAdminPage,
            },
        ]);
    }
    if (allowManageCredentialingClassifiers(userState)) {
        return availablePages;
    }
    const pages = [];
    if (allowManageHospitalsClassifier(userState)) {
        const hospitalClassifier = availablePages.filter((classifier) => classifier.name === capitalized(hospitalEntityName));
        pages.push(...hospitalClassifier);
    }
    if (allowManageSkillsAndTrainingsClassifiers(userState)) {
        const classifierNames = [
            capitalized(languageEntityName),
            capitalized(skillEntityName),
            capitalized(writtenAbilityEntityName),
            capitalized(languageFluencyEntityName),
            capitalized(trainingEntityName),
        ];
        const skillsAndTrainingsClassifiers = availablePages.filter((classifier) => classifierNames.includes(classifier.name));
        pages.push(...skillsAndTrainingsClassifiers);
    }
    return pages;
};
